import React from 'react';
import './Text.css';

interface TextProps {
  children: React.ReactNode;
  className?: string;
  isLink?: boolean;
  onClick?: () => void;
}

const Text: React.FC<TextProps> = ({ 
  children, 
  className = '', 
  isLink = false,
  onClick
}) => {
  const baseClass = 'text';
  const combinedClassName = `${baseClass} ${className}`;
  
  if (isLink) {
    return (
      <span 
        className={`${combinedClassName} text-link`}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onClick) {
            onClick();
          }
        }}
      >
        {children}
      </span>
    );
  }
  
  return (
    <span className={combinedClassName}>
      {children}
    </span>
  );
};

export default Text;